if($('.quick-navigation').length) {

    let quickNavigationItems = $('.quick-navigation-items a');

    function checkScrollPosition() {
        let scrollPosition = $(window).scrollTop();

        quickNavigationItems.each(function(i, el) {
            let nextElement = quickNavigationItems[i + 1] || null;

            let targetId = $(this).attr('href');
            if(targetId && targetId.startsWith('#')) {
                let targetElement = $(targetId);
                if(targetElement.length) {
                    let elementTop = targetElement.offset().top - 150;

                    if(nextElement) {
                        if(scrollPosition >= elementTop && scrollPosition < $(nextElement).offset().top - 150) {
                            quickNavigationItems.removeClass('active');
                            $(this).addClass('active');
                        }
                    } else {
                        if(scrollPosition >= elementTop) {
                            quickNavigationItems.removeClass('active');
                            $(this).addClass('active');
                        }
                    }
                }
            }
        });
    }

    $(window).on('scroll', function() {
        checkScrollPosition();
    });

    checkScrollPosition();

}
